import { get } from 'lodash';

export const parseDeviceList = (deviceList) => {
  if(!deviceList) {return null;}

  // The i18n here is very weird and non-standard
  // We index by many because we are either:
  // looking up (by deviceId, or, weirdly, by english name), or listing (by Locale)
  // the service API should change come i18n
  const devices = { byId: {}, byName: {}, byLocale: {} };
  const remove = [ // any shapefiles that we have an issue with
    'agleader-agsetup',
    'case-pro-700-iso'
  ];

  const filtered = deviceList.devices.filter((shapefile) => 
    !remove.some((deviceId) => deviceId === shapefile['device-id'])
  );

  filtered.forEach((device) => {
    let deviceId = device['device-id'];
    devices.byId[deviceId] = {};
    device.description.forEach((localeDesc) => {
      let { locale, text } = localeDesc;
      devices.byLocale[locale] = devices.byLocale[locale] || [];
      let entry = { value: deviceId, label: text };
      devices.byId[deviceId][locale] = entry;
      devices.byLocale[locale].push( entry );
      devices.byName[text] = entry;
    });
  });

  return devices;
};

export const parsePreferredDevice = (device) => {
  if (!device) { return null; }
  const devices = get(device, 'devices', []);
  return devices.length ? device.devices[0]['device-name'] : null;
};
